var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',_vm._g(_vm._b({style:({ width: _vm.$attrs.innerWidth || '' }),scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return [_vm._t("default",[_c('my-tooltip',{attrs:{"placement":"top","content":(_vm.$attrs.props && data[_vm.$attrs.props.label]) || data.label}},[_c('div',[_vm._v("\n          "+_vm._s((_vm.$attrs.props && data[_vm.$attrs.props.label]) || data.label)+"\n        ")])])])]}}],null,true)},'el-cascader',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0935dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipCascader.vue
// module id = null
// module chunks = 